export default __webpack_public_path__ + "static/media/global-icon-two-hover.befa0193.svg";